function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import localeKeys from '../../../../locales/keys';
import { REGEXES } from '../../../../customercare.constants';
import { CurrentTransactionIdSelector, IsSendingEmailSelector } from '../../../../reducers/selectors/customer.transactions.selectors';
import { CurrentCustomerIdSelector } from './../../../../reducers/selectors/customer.selectors';
import { clearTransactionsError, emailTransaction } from '../../../../reducers/actions/customer.transactions.actions';
var EmailPopupController = /*#__PURE__*/function () {
  function EmailPopupController($ngRedux, uiNotificationService) {
    _classCallCheck(this, EmailPopupController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      emailRegEx: REGEXES.EMAIL,
      errorMessages: [],
      localeKeys: localeKeys,
      model: {
        email: null
      },
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(EmailPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          isSendingEmail: IsSendingEmailSelector(store),
          transactionId: CurrentTransactionIdSelector(store)
        };
      };
      var controllerActions = {
        clearTransactionsError: clearTransactionsError,
        emailTransaction: emailTransaction
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.clearTransactionsError();
      this.disconnectRedux();
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      var _this2 = this;
      if (this.form.$valid) {
        var requestData = {
          Email: this.model.email,
          Id: this.state.transactionId
        };
        this.errorMessages = [];
        this.actions.emailTransaction(requestData, this.state.currentCustomerId).then(function () {
          _this2.onSuccess()();
        }, function (_ref) {
          var translatedMessage = _ref.translatedMessage;
          _this2.errorMessages.push(translatedMessage);
        });
      }
    }
  }]);
}();
export default {
  template: require('./email.popup.html'),
  controller: EmailPopupController,
  bindings: {
    onClose: '&',
    onSuccess: '&'
  }
};